document.addEventListener('DOMContentLoaded', () => {
    const STORAGE_KEY = 'jichica_favorites';

    // Configの安全な取得。PHP側から isPremium を受け取る想定
    const conf = typeof myJichicaConfig !== 'undefined' ? myJichicaConfig : {
        siteId: '0',
        shikuSlug: 'unknown',
        isJichikaiSite: false,
        isPremium: false // デフォルトは無料版扱い
    };

    const getFavs = () => JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];

    const container = document.createElement('div');
    container.id = 'my-jichica-floating-wrap';
    container.className = 'flex flex-al-c flex-dr-rr gap-2xs';
    document.body.appendChild(container);

    const renderUI = () => {
        const favs = getFavs();

        // IDと市区(sakaeku等)の両方が一致するか判定
        const isFav = favs.some(f => f.id === conf.siteId && f.shiku === conf.shikuSlug);
        const isMyPage = window.location.href.includes('/my-jichica/');

        // ★天才ヤムGの追加コード：現在が役員専用ページかどうかをURLで判定
        const isOfficerPage = window.location.href.includes('/officer/');

        let html = '';

        // ★印刷ボタン：有料版（isPremium が true）のときのみHTMLを生成
        if (conf.features && conf.features.print_support) {
            html += `
                <button id="jichica-print-toggle" class="jichica-fab flex flex-dr-c flex-al-c flex-jc-c c-pointer lh-1 print-btn" title="この記事を印刷する">
                    <span class="icon c-main"><span class="icon-printer-bold"></span></span>
                    <span class="label">印刷</span>
                </button>
            `;
        }

        // リストリンク（保存済みがある場合のみ）
        // if (favs.length > 0 && !isMyPage) {
        if (favs.length > 0 && !isMyPage && !isOfficerPage) {
            html += `
                <a href="/my-jichica" class="jichica-fab flex flex-dr-c flex-al-c flex-jc-c c-pointer list-btn lh-1">
                    <span class="icon c-pink"><span class="icon-book-open-bold"></span></span>
                    <span class="label">マイジチカリスト</span>
                </a>
            `;
        }

        // お気に入りトグルボタン（自治会サイト ＆ ★役員ページではない場合のみ）
        // if (conf.isJichikaiSite) {
        if (conf.isJichikaiSite && !isOfficerPage) {
            html += `
                <button id="jichica-fav-toggle" class="jichica-fab flex flex-dr-c flex-al-c flex-jc-c c-pointer lh-1 fav-btn ${isFav ? 'active' : ''}">
                    <span class="icon c-pink">${isFav ? '<span class="icon-heart-fill"></span>' : '<span class="icon-heart-bold"></span>'}</span>
                    <span class="label">マイジチカ</span>
                </button>
            `;
        }

        container.innerHTML = html;

        // ★印刷ボタンのクリックイベントを設定（ボタンが存在する場合のみ）
        const printBtn = document.getElementById('jichica-print-toggle');
        if (printBtn) {
            printBtn.onclick = (e) => {
                e.preventDefault();
                window.print();
            };
        }

        const btn = document.getElementById('jichica-fav-toggle');
        if (btn) {
            btn.onclick = (e) => {
                e.preventDefault();
                let currentFavs = getFavs();
                const currentlyFav = currentFavs.some(f => f.id === conf.siteId && f.shiku === conf.shikuSlug);

                if (currentlyFav) {
                    currentFavs = currentFavs.filter(f => !(f.id === conf.siteId && f.shiku === conf.shikuSlug));
                } else {
                    currentFavs.push({
                        id: conf.siteId,
                        shiku: conf.shikuSlug
                    });
                }

                localStorage.setItem(STORAGE_KEY, JSON.stringify(currentFavs));
                renderUI();
            };
        }
    };

    renderUI();
});